import { LocalDate, LocalTime } from 'js-joda';
import { SearchParams } from 'actions/AvailabilityActions';
import { SearchQueryStringParams } from 'components/search/utils';
import _ from 'lodash';

/**
 * initially, we take the query string to initialize search, then it gets
 * filled in later with default params.
 */
export function convertQueryStringToSearchParams(
  query: SearchQueryStringParams
): Partial<SearchParams> {
  const searchParams: Partial<SearchParams> = {
    ...query,
    date: query.date ? LocalDate.parse(query.date) : undefined,
    time: query.time ? LocalTime.parse(query.time) : undefined,
    size: query.size ? _.toNumber(query.size) : undefined,
    dateEnd: query.dateEnd ? LocalDate.parse(query.dateEnd) : undefined,
  };
  if (query.topLeftLat && query.topLeftLon && query.bottomRightLat && query.bottomRightLon) {
    const { topLeftLat, topLeftLon, bottomRightLat, bottomRightLon } = query;
    searchParams.boundingBox = {
      topLeft: { latitude: Number(topLeftLat), longitude: Number(topLeftLon) },
      bottomRight: { latitude: Number(bottomRightLat), longitude: Number(bottomRightLon) },
    };
  }
  return searchParams;
}
